import React from 'react';
import {
  Box,
  Typography,
  Paper,
  alpha,
} from '@mui/material';
import { formatCurrency } from '../../../../../../utils/helpers';
import { PaymentBreakdown } from '../payment-summary/PaymentSummary';

const PackageDetails = ({ appointment, hasPackage, getPackageDetails }) => {
  const packageData = appointment.serviceData?.packages?.[0] ||
                     appointment.package ||
                     appointment.selectedPackage ||
                     appointment.packageDetails ||
                     appointment.paymentDetails?.package;

  const addons = hasPackage ?
    packageData?.selectedAddons || appointment.paymentDetails?.package?.selectedAddons || [] :
    appointment.addons || appointment.selectedAddons || [];

  if (!packageData) return null;

  return (
    <Paper elevation={0} sx={{
      p: 2.5,
      borderRadius: 2,
      border: 1,
      borderColor: 'divider',
      bgcolor: (theme) => alpha(theme.palette.background.default, 0.5)
    }}>
      <Typography variant="subtitle2" color="primary.main" sx={{ mb: 2, fontWeight: 600 }}>
        {hasPackage ? "Package Details" : "Service Details"}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography variant="body1" color="text.primary" sx={{ fontWeight: 500 }}>
          {hasPackage ? (
            packageData?.name || packageData?.searchName || 'Package'
          ) : (
            appointment.serviceName
          )}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {hasPackage ?
            formatCurrency(packageData?.currentPrice || packageData?.price || 0) :
            formatCurrency(Number(parseFloat(appointment.servicePrice || appointment.price || 0).toFixed(2)))
          }
        </Typography>
      </Box>

      {hasPackage && packageData?.basePrice && packageData?.currentPrice && packageData?.basePrice !== packageData?.currentPrice && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              textDecoration: 'line-through',
              mr: 1
            }}
          >
            Original: {formatCurrency(packageData.basePrice)}
          </Typography>
          <Typography
            variant="caption"
            color="success.main"
          >
            ({packageData.discount}% off)
          </Typography>
        </Box>
      )}

      {addons?.map((addon, index) => (
        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
          <Typography variant="body1" color="text.primary" sx={{ fontWeight: 500 }}>
            {addon.name}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {hasPackage ? `Included` : formatCurrency(addon.price)}
          </Typography>
        </Box>
      ))}

      <PaymentBreakdown
        appointment={appointment}
        hasPackage={hasPackage}
        getPackageDetails={getPackageDetails}
      />
    </Paper>
  );
};

export default PackageDetails;
